// Theme: matrix
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'matrix',
  name: 'MATRIX',
  tagline: 'MATRIX',
  description: 'Codigo cascata verde com camadas epicas e glow controlado.',
  category: 'neon-cyber',
  tier: 'epic',
  basePrice: 2000,
  swatches: ['#0A0F0A', '#0D1F0D', '#00FF41', '#B3FFB3'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-matrix'
  },
  colorVars: {
    '--accent': '#00FF41',
    '--accent-foreground': '#0A0F0A',
    '--background': '#0A0F0A',
    '--border': '#1A4A1A',
    '--card': '#0D1F0D',
    '--card-border-active': 'rgba(0, 255, 65, 0.55)',
    '--card-completed': '#0A170B',
    '--card-foreground': '#B3FFB3',
    '--card-glow': 'rgba(0, 255, 65, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#B3FFB3',
    '--hold-fill': '#00FF41',
    '--input': '#1A4A1A',
    '--modal-bg': '#0A0F0A',
    '--modal-border': '#1A4A1A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#1A4A1A',
    '--muted-foreground': '#B3FFB3',
    '--nav-active': '#00FF41',
    '--nav-bg': '#0D1F0D',
    '--popover': '#0D1F0D',
    '--popover-foreground': '#B3FFB3',
    '--primary': '#00FF41',
    '--primary-foreground': '#0A0F0A',
    '--ring': '#00FF41',
    '--secondary': '#1A4A1A',
    '--secondary-foreground': '#B3FFB3',
    '--streak': '#00FF41',
    '--success': '#22c55e',
    '--success-foreground': '#0A0F0A',
    '--xp': '#00FF41',
    '--xp-bg': '#0D1F0D'
  },
  resolvedVars: {
    '--accent': '#00FF41',
    '--accent-foreground': '#0A0F0A',
    '--accent-foreground-hsl': '120 20% 5%',
    '--accent-foreground-oklch': 'from #0A0F0A l c h',
    '--accent-hsl': '135 100% 50%',
    '--accent-oklch': 'from #00FF41 l c h',
    '--background': '#0A0F0A',
    '--background-hsl': '120 20% 5%',
    '--background-oklch': 'from #0A0F0A l c h',
    '--border': '#1A4A1A',
    '--border-hsl': '120 48% 20%',
    '--border-oklch': 'from #1A4A1A l c h',
    '--border-w': '1px',
    '--card': '#0D1F0D',
    '--card-border-active': 'rgba(0, 255, 65, 0.55)',
    '--card-completed': '#0A170B',
    '--card-completed-hsl': '125 39% 6%',
    '--card-completed-oklch': 'from #0A170B l c h',
    '--card-foreground': '#B3FFB3',
    '--card-foreground-hsl': '120 100% 85%',
    '--card-foreground-oklch': 'from #B3FFB3 l c h',
    '--card-glow': 'rgba(0, 255, 65, 0.10)',
    '--card-hsl': '120 41% 9%',
    '--card-oklch': 'from #0D1F0D l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#B3FFB3',
    '--foreground-hsl': '120 100% 85%',
    '--foreground-oklch': 'from #B3FFB3 l c h',
    '--hold-fill': '#00FF41',
    '--hold-fill-hsl': '135 100% 50%',
    '--hold-fill-oklch': 'from #00FF41 l c h',
    '--input': '#1A4A1A',
    '--input-hsl': '120 48% 20%',
    '--input-oklch': 'from #1A4A1A l c h',
    '--modal-bg': '#0A0F0A',
    '--modal-bg-hsl': '120 20% 5%',
    '--modal-bg-oklch': 'from #0A0F0A l c h',
    '--modal-border': '#1A4A1A',
    '--modal-border-hsl': '120 48% 20%',
    '--modal-border-oklch': 'from #1A4A1A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#1A4A1A',
    '--muted-foreground': '#B3FFB3',
    '--muted-foreground-hsl': '120 100% 85%',
    '--muted-foreground-oklch': 'from #B3FFB3 l c h',
    '--muted-hsl': '120 48% 20%',
    '--muted-oklch': 'from #1A4A1A l c h',
    '--nav-active': '#00FF41',
    '--nav-active-hsl': '135 100% 50%',
    '--nav-active-oklch': 'from #00FF41 l c h',
    '--nav-bg': '#0D1F0D',
    '--nav-bg-hsl': '120 41% 9%',
    '--nav-bg-oklch': 'from #0D1F0D l c h',
    '--popover': '#0D1F0D',
    '--popover-foreground': '#B3FFB3',
    '--popover-foreground-hsl': '120 100% 85%',
    '--popover-foreground-oklch': 'from #B3FFB3 l c h',
    '--popover-hsl': '120 41% 9%',
    '--popover-oklch': 'from #0D1F0D l c h',
    '--primary': '#00FF41',
    '--primary-foreground': '#0A0F0A',
    '--primary-foreground-hsl': '120 20% 5%',
    '--primary-foreground-oklch': 'from #0A0F0A l c h',
    '--primary-hsl': '135 100% 50%',
    '--primary-oklch': 'from #00FF41 l c h',
    '--radius': '12px',
    '--ring': '#00FF41',
    '--ring-hsl': '135 100% 50%',
    '--ring-oklch': 'from #00FF41 l c h',
    '--secondary': '#1A4A1A',
    '--secondary-foreground': '#B3FFB3',
    '--secondary-foreground-hsl': '120 100% 85%',
    '--secondary-foreground-oklch': 'from #B3FFB3 l c h',
    '--secondary-hsl': '120 48% 20%',
    '--secondary-oklch': 'from #1A4A1A l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#00FF41',
    '--streak-hsl': '135 100% 50%',
    '--streak-oklch': 'from #00FF41 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0A0F0A',
    '--success-foreground-hsl': '120 20% 5%',
    '--success-foreground-oklch': 'from #0A0F0A l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(135 100% 50% / 0.15)',
    '--xp': '#00FF41',
    '--xp-bg': '#0D1F0D',
    '--xp-bg-hsl': '120 41% 9%',
    '--xp-bg-oklch': 'from #0D1F0D l c h',
    '--xp-hsl': '135 100% 50%',
    '--xp-oklch': 'from #00FF41 l c h'
  }
}
